require('./play-btn.styles.less');

var playing;

angular.module('bbl.directives')

.directive('playBtn', ['$sce', function($sce) {
  return {
    restrict: 'EA',
    replace: true,
    template: '<div class="play-btn" ng-class="{active: playing}">'+
      '<span class="fa fa-{{playing ? \'pause\' : \'play\'}}-circle-o" ng-click="toggle()">'+
        '<audio class="sample-genre" ng-src="{{getUrl()}}"></audio>'+
      '</span>'+
    '</div>',
    scope: {
      url: '=',
      autoReset: '=',
    },
    link: function($scope, $el) {
      $scope.playing = false;

      $scope.getUrl = function() {
        return $sce.trustAsResourceUrl($scope.url);
      };

      var audio = $el.find('audio')[0];
      audio.volume = 0.5;
      audio.load();

      $scope.play = function() {
        if(playing) {
          playing.pause();
        }

        if ($scope.autoReset) {
          audio.currentTime = 0;
        }

        audio.play();
        playing = audio;
      };

      $scope.pause = audio.pause.bind(audio);

      $scope.toggle = function() {
        var toggle = $scope.playing;

        $scope[toggle ? 'pause' : 'play']();
        $scope.playing = !toggle;
      };

      var syncState = function() {
        $scope.$apply($scope.playing = !audio.paused);
      };

      audio.onsuspend = syncState;
      audio.onpause = syncState;
    },
  };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/play-btn/play-btn.controller.js
 ** module id = 188
 ** module chunks = 0
 **/